module.exports = __webpack_public_path__ + "static/assets/7bb02f9c6e8c77206d09ff672bfaf9ec.png";